import React from "react";
import gql from "graphql-tag";
import { useQuery, useMutation } from "@apollo/react-hooks";
import styled from "styled-components";

const MenuStyle = styled.div`
  width: 100%;
  background-color: cyan;
`;

const listCatalogsQuery = gql`
  query listCatalogs {
    listCatalogs {
      id
      name
      communications {
        id
        name
      }
    }
  }
`;

const createCatalogMutation = gql`
  mutation createCatalog($name: String!) {
    createCatalog(input: { name: $name }) {
      id
      name
    }
  }
`;

const Menu = () => {
  const { loading, data, error } = useQuery(listCatalogsQuery);
  const [createCatalog] = useMutation(createCatalogMutation);
  return (
    <MenuStyle>
      <button
        onClick={e =>
          createCatalog({ variables: { name: "Nouveau Catalogue" } })
        }
      >
        Create a catalog
      </button>
      {loading && <p>loading</p>}
      {error && <h1>Error</h1>}
      {data && data.listCatalogs && (
        <ul>
          {data.listCatalogs.map(catalog => (
            <li key={catalog.id}>
              {catalog.name}
              <ul>
                {catalog.communications.map(communication => (
                  <li key={communication.id}>{communication.name}</li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      )}
    </MenuStyle>
  );
};

export default Menu;
